export default __webpack_public_path__ + "static/media/onoff.8f64fbc0.svg";